import { useState, useEffect, useRef } from 'react';

const readStorage = (key, fallback) => {
    if (!key) return fallback;
    try {
        const saved = sessionStorage.getItem(key);
        return saved !== null ? JSON.parse(saved) : fallback;
    } catch {
        return fallback;
    }
};

// Like useState, but persisted to sessionStorage under storageKey, and reloaded
// from storage whenever storageKey itself changes (e.g. switching tabs).
const usePersistedState = (storageKey, initialValue) => {
    const [state, setState] = useState(() => readStorage(storageKey, initialValue));
    const keyRef = useRef(storageKey);

    useEffect(() => {
        if (keyRef.current !== storageKey) {
            keyRef.current = storageKey;
            setState(readStorage(storageKey, initialValue));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [storageKey]);

    useEffect(() => {
        if (!storageKey) return;
        try {
            sessionStorage.setItem(storageKey, JSON.stringify(state));
        } catch {
            // ignore storage errors (quota, non-serializable state)
        }
    }, [storageKey, state]);

    return [state, setState];
};

export default usePersistedState;
